import React, { useState } from 'react';
import { WarningOutlined } from '@ant-design/icons';
import useGlobalContext from 'hooks/useGlobalContext';
import useFormatMessage from 'hooks/useFormatMessage';
import { useInterval } from 'ahooks';
import messages from './messages';

function getHash(html) {
  const match = html.match(/app\.js\?([^"]*)"/);
  if (match) {
    return match[1];
  }
  return null;
}

const CheckForUpdates = ({ url, delay }) => {
  const [codeHasChanged, setCodeHasChanged] = useState(false);
  const { modal } = useGlobalContext();
  const $t = useFormatMessage();

  const fetchSource = async () => {
    const res = await fetch(url, { cache: 'reload' });

    if (res.status !== 200) {
      return;
    }

    const newHtml = await res.text();

    const hash = getHash(newHtml);

    // eslint-disable-next-line
    if (__webpack_hash__ && hash && __webpack_hash__ !== hash) {
      modal.confirm({
        title: $t(messages.title),
        icon: <WarningOutlined />,
        content: $t(messages.content),
        onOk: () => window.location.reload(true),
        onCancel: () => setCodeHasChanged(false),
        okText: $t(messages.button),
      });
      setCodeHasChanged(true);
    }
  };

  useInterval(fetchSource, codeHasChanged ? null : delay);

  return null;
};

export default CheckForUpdates;
